import AlertBarFreeTrialExpired from './AlertBarFreeTrialExpired'

export default AlertBarFreeTrialExpired
// eslint-disable-next-line import/export
export * from './AlertBarFreeTrialExpired'
